module.exports = __webpack_public_path__ + "static/media/logo--white.f9615830.svg";